import React from "react"
import { IoLocationOutline } from "react-icons/io5"
import { TbPhoneCall } from "react-icons/tb"

export default function menuTopRow({ phone, address }) {
  return (
    <div className="bg-slate-900 text-white flex flex-col md:flex-row text-center md:justify-between py-2 px-4 sm:px-8 xl:px-24">
      <div className="text-xs flex items-center self-center">
        <IoLocationOutline className="inline-block text-amber-200 mr-2" />
        <span>{address}</span>
      </div>
      <div className="text-xs mt-2 sm:mt-0">
        <TbPhoneCall className="inline-block text-amber-200 mr-2" />
        <a href={`tel:+1${phone.replace(/\D/g, "")}`} className="underline">
          {phone}
        </a>
      </div>
    </div>
  )
}
